<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box">
        <div class="accountright_cont_box">
          <div
            class="flex_center_between_box acount_title"
            style="align-items: center"
          >
            <h2 class="history_box-head">
              {{ $t("AccountSecurity.Setupmysecurityquestions") }}
            </h2>

            <div style="display: flex">
              <button
                class="btn_blue flex_center change_btn_gray"
                v-if="Edit"
                @click="Edit = !Edit"
              >
                {{ $t("ContactInfo.Edit") }}
              </button>
              <div v-else style="display: flex">
                <button
                  class="btn_blue flex_center change_btn_mr10"
                  @click="changesave()"
                >
                  {{ $t("MyAccount.Save") }}
                </button>
                <button
                  class="btn_blue flex_center change_btn_gray"
                  @click="
                    (Edit = !Edit),
                      (CategoryVal = ''),
                      (CategoryVal2 = ''),
                      (CategoryVal3 = ''),
                      getUserSimpleInfo()
                  "
                >
                  {{ $t("MyAccount.Cancel") }}
                </button>
              </div>
            </div>
          </div>
          <div class="his_sel_box margin-top10">
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-select
                  style="width: 100%"
                  v-model="IndicatorsValType"
                  :placeholder="$t('AccountSecurity.Pleasechooseaquestion')"
                >
                  <el-option
                    v-for="(item, index) in type"
                    :key="index"
                    :label="
                      item.type == '1'
                        ? 'Online data'
                        : item.type == '2'
                        ? 'Offline data'
                        : item.type
                    "
                    :value="item.type"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  clearable
                  v-model="CategoryVal"
                  :placeholder="
                    $t('AccountSecurity.Pleaseentertheanswertothequestion')
                  "
                ></el-input>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-select
                  style="width: 100%"
                  v-model="IndicatorsValType"
                  :placeholder="$t('AccountSecurity.Pleasechooseaquestion')"
                >
                  <el-option
                    v-for="(item, index) in type"
                    :key="index"
                    :label="
                      item.type == '1'
                        ? 'Online data'
                        : item.type == '2'
                        ? 'Offline data'
                        : item.type
                    "
                    :value="item.type"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  clearable
                  v-model="CategoryVal"
                  :placeholder="
                    $t('AccountSecurity.Pleaseentertheanswertothequestion')
                  "
                ></el-input>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-select
                  style="width: 100%"
                  v-model="IndicatorsValType"
                  :placeholder="$t('AccountSecurity.Pleasechooseaquestion')"
                >
                  <el-option
                    v-for="(item, index) in type"
                    :key="index"
                    :label="
                      item.type == '1'
                        ? 'Online data'
                        : item.type == '2'
                        ? 'Offline data'
                        : item.type
                    "
                    :value="item.type"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="information-content account_form_itemA">
              <div class="sel_box computer_right_cont_box">
                <el-input
                  class="inline-input"
                  clearable
                  v-model="CategoryVal"
                  :placeholder="
                    $t('AccountSecurity.Pleaseentertheanswertothequestion')
                  "
                ></el-input>
              </div>
            </div>
          </div>
          <div
            class="flex_center_between_box margin-top40 margin-bottom20"
            style="align-items: center"
          >
            <h2 class="history_box-head">
              {{ $t("AccountSecurity.SessionTimeoutAutomaticLogoutSettings") }}
            </h2>
          </div>
          <div class="his_sel_box">
            <div class="information-content">
              <div class="sel_box sel_boxnum computer_right_cont_box">
                <el-select
                  style="width: 100%"
                  v-model="timeValue"
                  :disabled="Edit"
                  placeholder=""
                >
                  <el-option
                    v-for="(item, index) in timeValueOption"
                    :key="index"
                    @input="validateInput"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <span class="tixing margin-top10">{{
              $t("AccountSecurity.Thesystemwillautomatically")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import { setLoginRetentionTime } from "@/api/api.js";
import { getUserSimpleInfo } from "@/api/companyApi.js";
import ReLogin from "../../../components/ReLogin.vue";
export default {
  mixins: [mixins1],
  components: {
    ReLogin,
  },
  data() {
    return {
      reLoginVis: false,
      value1: "",
      CategoryVal: "",
      timeValueOption: [
        { text: "8 Mins", code: 8 },
        { text: "12 Mins", code: 12 },
        { text: "24 Mins", code: 24 },
      ],
      CategoryVal2: "",
      CategoryVal3: "",
      type: [],
      window: window,
      IndicatorsValType: "",
      timeValue: 8,
      Edit: true,
    };
  },
  beforeDestroy() {},
  destroyed() {},
  mounted() {
    this.getUserSimpleInfo();
  },

  methods: {
    getUserSimpleInfo() {
      getUserSimpleInfo()
        .then((res) => {
          this.timeValue = res.data.retentionHours;
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    validateInput() {
      // 获取输入的值
      const value = this.timeValue;

      // 使用正则表达式检查是否为整数
      if (!/^\d*$/.test(value)) {
        // 如果不是整数，清空输入框
        this.timeValue = "";
      }
    },
    changesave() {
      setLoginRetentionTime({
        hours: this.timeValue,
      }).then((res) => {
        if (res.code == 200) {
          this.getUserSimpleInfo();
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
          this.Edit = !this.Edit;
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.accountright_cont_box {
  height: calc(100vh - 136px);
}
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.history_box-head {
  font-size: 24px !important;
  line-height: 28px !important;
  color: #1290c9;
}

.sel_box {
  width: 40%;
  min-width: 530px;
  position: relative;
}

.sel_box /deep/ .el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
  border-color: #ccc !important;
  border-radius: 10px;
  font-size: 20px;
  padding-left: 10px !important;
  color: #1a2332;
}
.sel_box /deep/ .el-input__inner::placeholder {
  color: #cccccc;
}

.information-content {
  display: flex;
}
.account_form_itemA {
  align-items: center;
  margin-top: 16px !important;
  margin-bottom: 0 !important;
}
.his_sel_box .information-content {
  justify-content: flex-start;
  gap: 40px;
}
.btn_eee {
  background: #eee !important;
  color: #1a2332;
}
.el-select-dropdown__item {
  font-size: 20px !important;
  color: #1a2332;
}
/deep/ .el-radio__label {
  font-size: 20px;
  color: #1a2332;
}
.tixing {
  font-size: 14px;
  color: #f56b6b;
  line-height: 18px;
  width: 40%;
  min-width: 530px;
  display: block;
}
@media screen and (max-width: 1920px) {
  .history_box-head {
    font-size: 20px !important;
    line-height: 24px !important;
  }
  .account_form_itemA {
    margin-top: 12px !important;
  }
  .his_sel_box .information-content {
    gap: 30px;
  }
  .el-select-dropdown__item {
    font-size: 16px !important;
  }
  /deep/ .el-radio__label {
    font-size: 16px;
  }
  .sel_box {
    min-width: 400px;
  }

  .sel_box /deep/ .el-input__inner {
    height: 36px !important;
    line-height: 36px !important;
    border-radius: 7px;
    font-size: 16px;
  }
  .tixing {
    min-width: 400px;
  }
}
@media screen and (max-width: 1441px) {
  .history_box-head {
    font-size: 20px !important;
    line-height: 24px !important;
  }
  .account_form_itemA {
    margin-top: 10px !important;
  }
  .his_sel_box .information-content {
    gap: 26px;
  }
  .el-select-dropdown__item {
    font-size: 16px !important;
  }
  /deep/ .el-radio__label {
    font-size: 16px;
  }
  .sel_box {
    min-width: 360px;
  }

  .sel_box /deep/ .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
    border-radius: 6px;
    font-size: 14px;
  }
  .tixing {
    min-width: 360px;
  }
}
</style>
